import { createAction } from 'redux-actions';
import * as types from './constants';

export const fetchNavigationalInfo = createAction(types.NAVIGATION_DETAILS_REQUEST);
export const fetchNavigationalInfoSuccess = createAction(types.NAVIGATION_DETAILS_SUCCESS);
export const fetchNavigationalInfoFailure = createAction(types.NAVIGATION_DETAILS_FAILURE);

export const clearNavigationalInfo = createAction(types.CLEAR_NAVIGATION_DETAILS);

export const changeNavigationContext = createAction(types.CHANGE_NAVIGATION_CONTEXT);

export const toggleNavigationMenu = createAction(types.TOGGLE_NAVIGATION_MENU);
export const locationChange = createAction(types.LOCATION_CHANGE);

export const blockNavigation = createAction(types.BLOCK_NAVIGATION);
export const setPromptInfo = createAction(types.SET_PROMPT_INFO);

export const resetNotification = createAction(types.RESET_NOTIFICATION);
